/**
 * Builds the `search_performed` event fired when the header search bar is
 * submitted. Fires on every submit — including an empty query, since a
 * cleared search is itself a signal — see HeaderSearch.tsx.
 */

import { getSessionId } from "./session";
import type { SearchPerformedEvent } from "./types";

export const buildSearchPerformedEvent = (query: string): SearchPerformedEvent => ({
  name: "search_performed",
  occurred_at: new Date().toISOString(),
  session_id: getSessionId(),
  hub_id: null,
  project_id: null,
  properties: { query },
});
